import dynamic from 'next/dynamic';
import QRCode from 'react-qr-code';
import { useState } from 'react';
import { EmailShareButton, FacebookShareButton, WhatsappShareButton } from 'react-share';

import useWindowSize from '#app/hooks/useWindowSize';

import styles from './index.module.scss';
import { typo_16, typo_14 } from '../../../UI/atoms/typography/typography.module.scss';

const Typography = dynamic(() => import('../../../UI/atoms/typography/typography'));
const Button = dynamic(() => import('../../../UI/molecules/button/button'));

const icons = {
  facebook: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.671387 24.0044C0.674102 35.483 9.02099 45.2565 20.3577 47.0555V30.7478H14.4381V24.0044H20.3647V18.8711C20.0998 16.4387 20.9306 14.0145 22.6319 12.256C24.3332 10.4974 26.7285 9.58681 29.1684 9.77111C30.9196 9.79939 32.6665 9.95537 34.3951 10.2378V15.9754H31.4457C30.4304 15.8425 29.4096 16.1778 28.6709 16.887C27.9322 17.5962 27.5555 18.6025 27.6471 19.6224V24.0044H34.1127L33.0791 30.7501H27.6471V47.0555C39.9075 45.1178 48.5049 33.9206 47.2109 21.5756C45.9169 9.23064 35.1844 0.0596124 22.7886 0.706528C10.3929 1.35344 0.673357 11.5918 0.671387 24.0044Z"
        fill="black"
      />
    </svg>
  ),
  whatsapp: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4765 39.9314L14.1789 40.3477C17.1303 42.0992 20.514 43.0255 23.9647 43.0274H23.9723C34.5691 43.0274 43.1939 34.4045 43.1983 23.8069C43.2 18.6708 41.2022 13.8417 37.5722 10.2089C33.942 6.57629 29.1152 4.57429 23.9796 4.57217C13.3742 4.57217 4.74971 13.1939 4.74548 23.7912C4.74407 27.4228 5.76 30.9594 7.68485 34.0197L8.14236 34.747L6.19964 41.8393L13.4765 39.9314ZM0.645752 47.3332L3.92737 35.3506C1.90326 31.8436 0.838402 27.8653 0.840048 23.7898C0.844988 11.0397 11.2214 0.666504 23.9723 0.666504C30.1598 0.669091 35.9675 3.07732 40.3352 7.44803C44.7021 11.819 47.1064 17.6293 47.1042 23.8084C47.0988 36.5578 36.7207 46.9328 23.9723 46.9328C23.9713 46.9328 23.9727 46.9328 23.9723 46.9328H23.9624C20.0911 46.9312 16.287 45.9604 12.9085 44.1176L0.645752 47.3332Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1772 14.1294C17.7441 13.1668 17.2885 13.1475 16.8766 13.1306C16.5395 13.1163 16.154 13.1172 15.7689 13.1172C15.3834 13.1172 14.7572 13.2619 14.2278 13.8403C13.6978 14.4187 12.2046 15.8169 12.2046 18.6605C12.2046 21.5044 14.276 24.2523 14.5646 24.6383C14.8537 25.0236 18.5632 31.0458 24.4379 33.3625C29.3205 35.2878 30.3141 34.9049 31.3737 34.8084C32.4334 34.7122 34.7934 33.4107 35.2749 32.061C35.7567 30.7115 35.7567 29.5547 35.6123 29.3131C35.4678 29.0722 35.0823 28.9276 34.5043 28.6387C33.9262 28.3496 31.0847 26.9512 30.5549 26.7583C30.025 26.5657 29.6397 26.4695 29.2541 27.0481C28.8688 27.6261 27.7619 28.9276 27.4246 29.3131C27.0875 29.6993 26.7502 29.7476 26.1722 29.4585C25.594 29.1685 23.7325 28.5588 21.5242 26.5899C19.8059 25.0579 18.646 23.166 18.3087 22.5873C17.9716 22.0094 18.2727 21.6963 18.5625 21.4082C18.8222 21.1492 19.1406 20.7333 19.4297 20.396C19.7181 20.0584 19.8143 19.8176 20.007 19.432C20.1999 19.0463 20.1034 18.7087 19.959 18.4196C19.8143 18.1305 18.6911 15.2723 18.1772 14.1294Z"
        fill="black"
      />
    </svg>
  ),
  email: (
    <svg
      width="42"
      height="34"
      viewBox="0 0 42 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.8 34H4.2C1.8804 34 0 32.0972 0 29.75V4.06513C0.0978775 1.79042 1.94992 -0.0021513 4.2 1.93781e-06H37.8C40.1196 1.93781e-06 42 1.90279 42 4.25V29.75C42 32.0972 40.1196 34 37.8 34ZM4.2 8.2195V29.75H37.8V8.2195L21 19.55L4.2 8.2195ZM5.88 4.25L21 14.45L36.12 4.25H5.88Z"
        fill="black"
      />
    </svg>
  )
};

const ShareModal = ({ link }) => {
  const [copied, setCopied] = useState(false);
  const { isDesktop } = useWindowSize();

  const copy = async text => {
    await navigator.clipboard.writeText(text);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2500);
  };

  const handleFocus = event => event.target.select();

  return (
    <section className={styles.modal}>
      <Typography
        fontSize={[32, 20]}
        lineHeight={[36, 24]}
        fontWeight={700}
        margin={{ bottom: [32, 24] }}
        tag="p"
      >
        ¡Compártelo con tu familia y amigos!
      </Typography>

      <div className={styles.container}>
        {/* Information */}
        <div className={styles.information}>
          <div className={styles.social}>
            <Typography
              variant={typo_16}
              margin={{ bottom: [8, 8] }}
              fontWeight={700}
              tag="p"
            >
              Comparte en:
            </Typography>

            <ul className={styles.social_container}>
              <FacebookShareButton url={link}>{icons.facebook}</FacebookShareButton>
              <WhatsappShareButton url={link}>{icons.whatsapp}</WhatsappShareButton>
              <EmailShareButton
                body={`¡Hola, conoce los mejores proyectos de Crack The Code! 🎉 
Escuela online de programación para niños y adolescentes
`}
                url={link}
              >
                {icons.email}
              </EmailShareButton>
            </ul>
          </div>

          <div className={styles.share}>
            <Typography
              variant={typo_16}
              margin={{ bottom: [8, 8] }}
              fontWeight={700}
              tag="p"
            >
              Copia y pega este enlace:
            </Typography>

            <div className={styles.share_container}>
              <div className={styles.share_container_info}>
                <input
                  className={styles.text}
                  type="text"
                  value={link}
                  onFocus={handleFocus}
                />

                {copied && (
                  <Typography
                    variant={typo_14}
                    margin={{ top: [4, 8] }}
                    color="#00BD79"
                    tag="p"
                  >
                    Enlace copiado, puedes pegarlo donde quieras compartirlo.
                  </Typography>
                )}
              </div>

              <Button
                variant="black"
                height="48px"
                width="137px"
                textOptions={{
                  fontSize: [20, 20],
                  lineHeight: [21, 21],
                  fontWeight: 700
                }}
                onClick={() => copy(link)}
              >
                {copied ? '¡Copiado!' : 'Copiar'}
              </Button>
            </div>
          </div>
        </div>

        {/* QR */}
        {isDesktop && (
          <div className={styles.qr}>
            <Typography
              fontSize={[16, 16]}
              lineHeight={[18, 18]}
              margin={{ bottom: [8, 8] }}
              fontWeight={700}
              tag="p"
            >
              O míralo y comparte desde un teléfono:
            </Typography>

            <QRCode
              size={173}
              style={{ height: 'auto', maxWidth: '100%', width: '150px' }}
              value={link}
              viewBox={`0 0 256 256`}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default ShareModal;
